function IconAlertCircle({ size = 41, color = '#909296' }: { size?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 41 40"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M20.5 13.333V20m0 6.667h.017M35.5 20c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15Z"
      />
    </svg>
  );
}
IconAlertCircle.displayName = 'IconAlertCircle';

export { IconAlertCircle };
